export const refs = {
  form: document.querySelector('#task-form'),
  taskList: document.querySelector('#task-list'),
};
